// This file is auto-generated by @hey-api/openapi-ts

import type {
  Options as ClientOptions,
  TDataShape,
  Client,
} from '@hey-api/client-fetch';
import type {
  GetEventsBaseDataData,
  GetEventsBaseDataResponse,
  GetEventsSearchListData,
  GetEventsSearchListResponse,
  GetExcursionOperatorData,
  GetExcursionOperatorResponse,
  GetExcursionsBaseDataData,
  GetExcursionsBaseDataResponse,
  GetExcursionsSearchByPortData,
  GetExcursionsSearchByPortResponse,
  GetExcursionsSearchListData,
  GetExcursionsSearchListResponse,
  GetExcursionsV2BaseDataData,
  GetExcursionsV2BaseDataResponse,
  GetExcursionsV2InvalidateCacheData,
  GetExcursionsV2RefreshCacheData,
  GetExcursionsV2SearchListData,
  GetExcursionsV2SearchListResponse,
} from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get Base Data
 */
export const getEventsBaseData = <ThrowOnError extends boolean = false>(
  options?: Options<GetEventsBaseDataData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetEventsBaseDataResponse,
    unknown,
    ThrowOnError
  >({
    url: '/events/baseData',
    ...options,
  });
};

/**
 * Search List
 */
export const getEventsSearchList = <ThrowOnError extends boolean = false>(
  options?: Options<GetEventsSearchListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetEventsSearchListResponse,
    unknown,
    ThrowOnError
  >({
    url: '/events/searchList',
    ...options,
  });
};

/**
 * Get Operator
 */
export const getExcursionOperator = <ThrowOnError extends boolean = false>(
  options?: Options<GetExcursionOperatorData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetExcursionOperatorResponse,
    unknown,
    ThrowOnError
  >({
    url: '/excursionOperator',
    ...options,
  });
};

/**
 * Get Filters
 */
export const getExcursionsBaseData = <ThrowOnError extends boolean = false>(
  options?: Options<GetExcursionsBaseDataData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetExcursionsBaseDataResponse,
    unknown,
    ThrowOnError
  >({
    url: '/excursions/baseData',
    ...options,
  });
};

/**
 * Search By Port
 */
export const getExcursionsSearchByPort = <ThrowOnError extends boolean = false>(
  options?: Options<GetExcursionsSearchByPortData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetExcursionsSearchByPortResponse,
    unknown,
    ThrowOnError
  >({
    url: '/excursions/searchByPort',
    ...options,
  });
};

/**
 * Search
 */
export const getExcursionsSearchList = <ThrowOnError extends boolean = false>(
  options?: Options<GetExcursionsSearchListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetExcursionsSearchListResponse,
    unknown,
    ThrowOnError
  >({
    url: '/excursions/searchList',
    ...options,
  });
};

/**
 * Get Base Data
 */
export const getExcursionsV2BaseData = <ThrowOnError extends boolean = false>(
  options?: Options<GetExcursionsV2BaseDataData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetExcursionsV2BaseDataResponse,
    unknown,
    ThrowOnError
  >({
    url: '/excursions/v2/baseData',
    ...options,
  });
};

/**
 * Invalidate
 */
export const getExcursionsV2InvalidateCache = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetExcursionsV2InvalidateCacheData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      url: '/excursions/v2/invalidate-cache',
      ...options,
    },
  );
};

/**
 * Refresh Cache
 */
export const getExcursionsV2RefreshCache = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetExcursionsV2RefreshCacheData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      url: '/excursions/v2/refresh-cache',
      ...options,
    },
  );
};

/**
 * Search List
 */
export const getExcursionsV2SearchList = <ThrowOnError extends boolean = false>(
  options?: Options<GetExcursionsV2SearchListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetExcursionsV2SearchListResponse,
    unknown,
    ThrowOnError
  >({
    url: '/excursions/v2/searchList',
    ...options,
  });
};
